import {
  BusinessLineSalesItemOptionModel,
  ProactivePrescriptionRuleModel,
  ProactivePrescriptionVeterinarianRuleModel,
} from '@common/models';
import { ServiceMethodOptions } from '@common/services/types';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class ProactivePrescriptionService {
  private static baseUrl: string = '/api/';

  static tags = {
    addProactivePrescriptionRule: 'addProactivePrescriptionRule',
    updateProactivePrescriptionRule: 'updateProactivePrescriptionRule',
    deleteProactivePrescriptionRule: 'deleteProactivePrescriptionRule',
    getProactivePrescriptionRule: 'getProactivePrescriptionRule',
    getProactivePrescriptionRules: 'getProactivePrescriptionRules',
    getSalesItemOptionsByProactivePrescriptionRule:
      'getSalesItemOptionsByProactivePrescriptionRule',
    addProactivePrescriptionVeterinarianRule:
      'addProactivePrescriptionVeterinarianRule',
    updateProactivePrescriptionVeterinarianRule:
      'updateProactivePrescriptionVeterinarianRule',
  };

  static addProactivePrescriptionRule(
    data: ProactivePrescriptionRuleModel,
    options?: ServiceMethodOptions,
  ) {
    return trackPromise(
      new Promise<ProactivePrescriptionRuleModel>((resolve, reject) => {
        http(`${this.baseUrl}proactiveprescriptionrule`)
          .post<ProactivePrescriptionRuleModel>(data)
          .then((response) => {
            resolve(new ProactivePrescriptionRuleModel(response));
          })
          .catch((err) => reject(err));
      }),
      this.tags.addProactivePrescriptionRule,
    );
  }

  static updateProactivePrescriptionRule(
    data: ProactivePrescriptionRuleModel,
    options?: ServiceMethodOptions,
  ) {
    return trackPromise(
      new Promise<ProactivePrescriptionRuleModel>((resolve, reject) => {
        http(
          `${this.baseUrl}proactiveprescriptionrule/${data.proactivePrescriptionRuleId}`,
        )
          .put<ProactivePrescriptionRuleModel>(data)
          .then((response) => {
            resolve(new ProactivePrescriptionRuleModel(response));
          })
          .catch((err) => reject(err));
      }),
      this.tags.updateProactivePrescriptionRule,
    );
  }

  static deleteProactivePrescriptionRule(
    proactivePrescriptionRuleId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(
          `${this.baseUrl}proactiveprescriptionrule/${proactivePrescriptionRuleId}`,
        )
          .delete()
          .then(() => resolve(true))
          .catch((err) => reject(err));
      }),
      this.tags.deleteProactivePrescriptionRule,
    );
  }

  static getProactivePrescriptionRule(
    proactivePrescriptionRuleId: number,
    options?: ServiceMethodOptions,
  ): Promise<ProactivePrescriptionRuleModel> {
    return trackPromise(
      new Promise<ProactivePrescriptionRuleModel>((resolve, reject) => {
        http(
          `${this.baseUrl}proactiveprescriptionrule/${proactivePrescriptionRuleId}`,
        )
          .get<ProactivePrescriptionRuleModel>()
          .then((response) =>
            resolve(new ProactivePrescriptionRuleModel(response)),
          )
          .catch((err) => reject(err));
      }),
      this.tags.getProactivePrescriptionRule,
    );
  }

  static getProactivePrescriptionRules(
    options?: ServiceMethodOptions,
  ): Promise<ProactivePrescriptionRuleModel[]> {
    return trackPromise(
      new Promise<ProactivePrescriptionRuleModel[]>((resolve, reject) => {
        http(`${this.baseUrl}proactiveprescriptionrules`)
          .get<ProactivePrescriptionRuleModel[]>()
          .then((response) =>
            resolve(
              response.map((item) => new ProactivePrescriptionRuleModel(item)),
            ),
          )
          .catch((err) => reject(err));
      }),
      this.tags.getProactivePrescriptionRules,
    );
  }

  static getSalesItemOptionsByProactivePrescriptionRule(
    proactivePrescriptionRuleId: number,
  ): Promise<BusinessLineSalesItemOptionModel[]> {
    return trackPromise(
      new Promise<BusinessLineSalesItemOptionModel[]>((resolve, reject) => {
        http(
          `${this.baseUrl}proactiveprescriptionrule/getSalesItemOptionsByProactivePrescriptionRuleId/${proactivePrescriptionRuleId}`,
        )
          .get<BusinessLineSalesItemOptionModel[]>()
          .then((response) =>
            resolve(
              response.map(
                (item) => new BusinessLineSalesItemOptionModel(item),
              ),
            ),
          )
          .catch((err) => reject(err));
      }),
      this.tags.getProactivePrescriptionRules,
    );
  }

  static addProactiveRxVetRule(
    data: ProactivePrescriptionVeterinarianRuleModel,
  ) {
    return trackPromise(
      new Promise<ProactivePrescriptionVeterinarianRuleModel>(
        (resolve, reject) => {
          http(`${this.baseUrl}proactivePrescriptionVeterinarianRule`)
            .post<ProactivePrescriptionVeterinarianRuleModel>(data)
            .then((response) =>
              resolve(new ProactivePrescriptionVeterinarianRuleModel(response)),
            )
            .catch((err) => reject(err));
        },
      ),
      this.tags.addProactivePrescriptionVeterinarianRule,
    );
  }

  static updateProactiveRxVetRule(
    data: ProactivePrescriptionVeterinarianRuleModel,
  ) {
    return trackPromise(
      new Promise<ProactivePrescriptionVeterinarianRuleModel>(
        (resolve, reject) => {
          http(
            `${this.baseUrl}proactivePrescriptionVeterinarianRule/${data.proactivePrescriptionVeterinarianRuleId}`,
          )
            .put<ProactivePrescriptionVeterinarianRuleModel>(data)
            .then((response) =>
              resolve(new ProactivePrescriptionVeterinarianRuleModel(response)),
            )
            .catch((err) => reject(err));
        },
      ),
      this.tags.updateProactivePrescriptionVeterinarianRule,
    );
  }
}
